import { Flex, Grid, Heading } from "@radix-ui/themes";
import styles from "./hoverable-image-link.module.css";
import { Link } from "~/components/RouterLink";
import { OptimizedImage } from "~/components/OptimizedImage";

export function HoverableImageLink({
  imageUrl,
  label,
  backgroundPosition,
  to,
}: {
  imageUrl: string;
  label: string;
  backgroundPosition?: string;
  to: string;
}) {
  return (
    <Grid
      asChild
      width="100%"
      height="100%"
      columns="6"
      rows="5"
      overflow="hidden"
      className={styles.hoverableImageContainer}
    >
      <Link to={to}>
        <Flex
          gridRow="1/7"
          gridColumn="1/7"
          className={styles.hoverableImage}
          asChild
        >
          <OptimizedImage
            src={imageUrl}
            alt=""
            aria-hidden="true"
            width="780"
            height="520"
            style={{
              ...(backgroundPosition ? { objectPosition: backgroundPosition } : {}),
            }}
          />
        </Flex>
        <Flex
          gridRow="1/7"
          gridColumn="1/7"
          className={styles.imageOverlay}
        ></Flex>
        <Flex gridRow="1/7" gridColumn="1/7" justify="center" align="center">
          <Heading as="h3" className={styles.hoverableImageText}>
            {label}
          </Heading>
        </Flex>
      </Link>
    </Grid>
  );
}
